import React from "react";
import Icon from "components/AppIcon";
import Button from "components/ui/Button";

const ConfirmationModal = ({ isOpen, onClose, formData }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{ background: "rgba(0,0,0,0.5)" }}>
      <div
        className="w-full max-w-md rounded-xl p-6 md:p-8 shadow-elevation-4"
        style={{ background: "var(--color-card)", border: "1px solid var(--color-border)" }}
      >
        <div className="flex flex-col items-center text-center">
          <div className="w-16 h-16 rounded-full flex items-center justify-center mb-4" style={{ background: "var(--color-success)20" }}>
            <Icon name="CheckCircle" size={40} color="var(--color-success)" />
          </div>
          <h2 className="text-xl font-bold mb-2" style={{ fontFamily: "var(--font-heading)", color: "var(--color-foreground)" }}>
            ¡Solicitud Enviada!
          </h2>
          <p className="text-sm mb-4" style={{ fontFamily: "var(--font-body)", color: "var(--color-muted-foreground)" }}>
            Su solicitud de registro ha sido recibida exitosamente. Hemos enviado un correo de confirmación a:
          </p>
          <div className="px-4 py-2 rounded-lg mb-4 w-full" style={{ background: "var(--color-muted)" }}>
            <p className="text-sm font-semibold" style={{ fontFamily: "var(--font-data)", color: "var(--color-primary)" }}>
              {formData?.email}
            </p>
          </div>
          <div className="w-full rounded-lg p-4 mb-6 text-left" style={{ background: "var(--color-muted)", border: "1px solid var(--color-border)" }}>
            <p className="text-xs font-semibold mb-2" style={{ fontFamily: "var(--font-caption)", color: "var(--color-foreground)" }}>
              Próximos pasos:
            </p>
            <ul className="space-y-1">
              {[
                "Un administrador revisará su solicitud",
                "Recibirá un correo cuando su cuenta sea activada",
                "El proceso puede tomar entre 1 y 3 días hábiles",
              ]?.map((step, i) => (
                <li key={i} className="flex items-start gap-2 text-xs" style={{ fontFamily: "var(--font-caption)", color: "var(--color-muted-foreground)" }}>
                  <Icon name="ArrowRight" size={12} color="var(--color-primary)" className="mt-0.5 flex-shrink-0" />
                  {step}
                </li>
              ))}
            </ul>
          </div>
          <Button variant="default" onClick={onClose} fullWidth iconName="Home" iconPosition="left">
            Entendido
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;